module.exports = __webpack_public_path__ + "img/498127-1.5c9b4ed5.png";